previousReader